import { isEnabled } from "lib/@components/feature"
import { hasDemand } from "lib/authorization/has-demand"
import { registerFeatureWithDescription } from "lib/features"
import { Lazy } from "lib/make-lazy"
import { registerSystemAdminTab } from "routes/sfg20-admin/plugins/system-tab/register-system-admin-tab"
import { FEATURE_FLAG_TIMING_REPAIR } from "./server/feature-flag-timing-repair.mjs"
import { PRIORITY_DATA, SECTION_DATA } from "routes/sfg20-admin/plugins/system-tab/system-admin-sections"

registerFeatureWithDescription({
    numericalId: 5004,
    id: FEATURE_FLAG_TIMING_REPAIR,
    name: "Timing Repair",
    descriptionLines: [
        "Analyses historic system-generated schedule-timing payload overrides for corruption.",
        "Analyse is read-only; repairing a schedule is an explicit, separate action.",
    ],
    internalUseOnly: true,
})

// This sensitive tool requires the feature flag, admin access, and the literal `$admin-timings`
// demand. The `$` makes this a required individual grant: the admin wildcard cannot satisfy it
// (api/library/authorization/index.mjs:63-70).
registerSystemAdminTab(
    "Timing Repair",
    <Lazy importer={() => import("./timing-repair")} extract="TimingRepair" />,
    () => isEnabled(FEATURE_FLAG_TIMING_REPAIR) && hasDemand("admin") && hasDemand("$admin-timings"),
    PRIORITY_DATA + 20,
    undefined,
    SECTION_DATA
)
